// store/modules/modals.js
export default {
  namespaced: true,
  state: {
    depositModalIsVisible: false,
    cartDropdownIsVisible: false,
    error: "",
  },
  getters: {
    depositModalIsVisible: (state) => state.depositModalIsVisible,
    cartDropdownIsVisible: (state) => state.cartDropdownIsVisible,
    error: (state) => state.error,
  },
  mutations: {
    openDepositModal(state) {
      state.depositModalIsVisible = true;
      document.body.style.overflow = "hidden";
    },
    closeDepositModal(state) {
      state.depositModalIsVisible = false;
      document.body.style.overflow = "auto";
    },
    openCartDropdown(state) {
      state.cartDropdownIsVisible = true;
    },
    closeCartDropdown(state) {
      state.cartDropdownIsVisible = false;
    },
  },
  actions: {
    openDepositModal({ commit }) {
      commit("openDepositModal");
    },
    closeDepositModal({ commit }) {
      commit("closeDepositModal");
    },
    openCartDropdown({ commit }) {
      commit("openCartDropdown");
    },
    closeCartDropdown({ commit }) {
      commit("closeCartDropdown");
    },
  },
};
